import { AApi } from './AApi';
import type { ApiResult } from '../types/api.types';
import type { SearchAnswerBody } from '../types/search.types';

/** The big search over every module: `/search`. */
export class SearchApi extends AApi {
    public search(query: string): Promise<ApiResult<SearchAnswerBody>> {
        return this.Client.get(`${this.VersionPath}/search`, { q: query });
    }

    /** Only the best hit of each module. */
    public searchBest(query: string): Promise<ApiResult<SearchAnswerBody>> {
        return this.Client.get(`${this.VersionPath}/search`, { q: query, best: '1' });
    }
}
